import React, { useEffect, useState } from "react";
import Head from 'next/head'
import DefaultLayout from '../presentation/layouts/default'
import EndorsementsPresenter from '../presentation/presenters/endorsements-presenter'
import { GetPageDefaultsInteractor } from "../domain/usecases/get-page-defaults-interactor";
import { SiteInfoService } from "../data/services/data-site-info-service";
import { ListEndorsementsInteractor } from "../domain/usecases/list-endorsements-interactor";
import { EndorsementService } from "../data/services/data-endorsement-service";

export default function EndorsementsPage() {
  const [siteInfo, setSiteInfo] = useState(null)
  const [endorsements, setEndorsements] = useState(null)

  useEffect(() => {
    fetchPageDefaults();
    fetchEndorsements();
  }, []);

  const fetchPageDefaults = async () => {
    const getPageDefaultsInteractor = new GetPageDefaultsInteractor(
      new SiteInfoService()
    );
    const siteInfo = await getPageDefaultsInteractor.getSiteInfo()
    setSiteInfo(siteInfo)
  }

  const fetchEndorsements = async () => {
    const listEndorsementsInteractor = new ListEndorsementsInteractor(
      new EndorsementService()
    );
    const endorsements = await listEndorsementsInteractor.listEndorsements()
    setEndorsements(endorsements)
  }

  return (
    <DefaultLayout siteInfo={siteInfo}>
      <Head>
        <title>{siteInfo?.title}</title>
        <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossOrigin="anonymous" />
      </Head>
      <EndorsementsPresenter endorsements={endorsements} />
    </DefaultLayout>
  )
}
